import { ProductUid } from '../../domain/models/related-products.models';

import { ProductPublicModels } from '@features/products/product';

function getProductColorId(product) {
    if (product?.uid) {
        return product.uid.slice(-3);
    }
    if (product?.status?.selectedColor) {
        return product.status.selectedColor.id;
    }
    return undefined;
}

export function mapProductToProductUid(product): ProductUid {
    const productColors = product.colors || [];
    const productUid = {
        section: product.sectionNameEN ? product.sectionNameEN : undefined,
        product_id: product.id ? product.id : product.product_id,
        uid: product.id ? product.id : product.product_id,
        sku: product.sku ? product.sku : undefined, // para mocaco
        colorId: getProductColorId(product) || product.colorId,
        mocaId: product.mocaId,
        timestamp: product.timestamp ? product.timestamp : new Date().getTime(),
        arraySku: productColors.reduce((acc, curr) => {
            return acc.concat(curr.sizes.map((colorSize) => colorSize.sku));
        }, []),
    };

    return productUid;
}

export const mapProductsToProductUids = (products: ProductPublicModels.PublicProduct[]): ProductUid[] => {
    return products.filter((product) =>
        product !== undefined).map((product) => mapProductToProductUid(product));
};
